module.exports = __webpack_public_path__ + "static/googleStoreImage.7a60f99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/googleStoreImage.png
// module id = 33
// module chunks = 17199820305509 35783957827783 227738586966018